var exports = {
  "q0": "xa15a2ab7--160787--buttons-outer",
  "WY": "xa15a2ab7--160787--complaint-outer",
};

module.exports = exports;
